// ── 1 Kunde ── Zustand und Rumpf (rein).

import type { Tenant } from "../../api/types";

export interface CustomerState {
  name: string;
  slug: string;
  contact_name: string;
  contact_email: string;
}

export type CustomerBody = CustomerState;

export function customerFromTenant(t: Tenant | null): CustomerState {
  return { name: t?.name ?? "", slug: t?.slug ?? "", contact_name: t?.contact_name ?? "", contact_email: t?.contact_email ?? "" };
}

/** Wie früher: nur der Slug wird bereinigt (getrimmt, klein) — der Rest geht, wie er dasteht. */
export function customerToBody(s: CustomerState): CustomerBody {
  return { name: s.name, slug: normalizeSlug(s.slug), contact_name: s.contact_name, contact_email: s.contact_email };
}

export const normalizeSlug = (slug: string): string => slug.trim().toLowerCase();
